import { createSelector } from 'reselect';
import identity from 'ramda/es/identity';

import { getIsAppConnected } from 'app/selectors/applications';


export default createSelector(
  (state, { studentId, filter }) => filter.filter(({ string }) => (
    string === 'all' ? true : getIsAppConnected(state, { id: studentId, app: string })
  )),
  identity
);
